import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  dashboardService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    function (runtimeConstant, $http, $q, $filter, webApiSettings) {
      function handleError(err, status) {
        if (status === 404) {
          var error = {
            error: $filter('translate')('ERROR'),
            error_description: $filter('translate')('REVISION NOT FOUND'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function getSentDocumentsMonth() {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/sentDocumentsMonth/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function getRepositoryGbs() {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/sizeByRepository/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function getUsedGbs() {
        var deferred = $q.defer();

        var url = webApiSettings.apiServiceBaseUri + 'dashboard/usedGbs/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function countDocuments() {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/countDocuments/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            deferred.resolve(response.data);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function countFolders() {
        var deferred = $q.defer();

        var url = webApiSettings.apiServiceBaseUri + 'dashboard/countFolders/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            deferred.resolve(response.data);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function countRegistredUsers() {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/countRegistredUsers/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function countIndexedPages() {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/countIndexedPages/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            deferred.resolve(response.data);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function indexedPagesByUser() {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/indexedPagesByUser/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function mostActiveUsers() {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/mostActiveUsers/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            var result = resolveReferences(response.data);
            deferred.resolve(result);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function additionalFieldsReport(filter) {
        var deferred = $q.defer();

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}dashboard/additionalFields`,
            filter
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => deferred.reject(handleError(err.data, err.status)));

        return deferred.promise;
      }

      function additionalFieldListItems(idAdditionalField) {
        var deferred = $q.defer();

        $http
          .get(
            `${webApiSettings.apiServiceBaseUri}lists/listByAddField/${idAdditionalField}`,
            {
              ignoreLoadingBar: true,
            }
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => deferred.reject(handleError(err.data, err.status)));

        return deferred.promise;
      }

      function generateAdditionalFieldReport(reportFilter) {
        var deferred = $q.defer();

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}reports/generate`,
            reportFilter,
            {
              responseType: 'blob',
              ignoreLoadingBar: true,
            }
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function generateExpiredRevisionsReport(reportFilter) {
        var deferred = $q.defer();
        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}reports/generate`,
            reportFilter,
            {
              responseType: 'blob',
              ignoreLoadingBar: true,
            }
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function generateIndexedPagesReport(reportFilter) {
        var deferred = $q.defer();

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}reports/generate`,
            reportFilter,
            {
              responseType: 'blob',
              ignoreLoadingBar: true,
            }
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function generateauditUserReport(reportFilter) {
        var deferred = $q.defer();
        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}reports/generate`,
            reportFilter,
            {
              responseType: 'blob',
              ignoreLoadingBar: true,
            }
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function generateauditDocumentReport(reportFilter) {
        var deferred = $q.defer();
        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}reports/generate`,
            reportFilter,
            {
              responseType: 'blob',
              ignoreLoadingBar: true,
            }
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });
        return deferred.promise;
      }

      function generatePublicLinkReport(reportFilter) {
        var deferred = $q.defer();
        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}reports/generate`,
            reportFilter,
            {
              responseType: 'blob',
              ignoreLoadingBar: true,
            }
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function generateDocD4SignReport(reportFilter) {
        var deferred = $q.defer();
        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}reports/generate`,
            reportFilter,
            {
              responseType: 'blob',
              ignoreLoadingBar: true,
            }
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function getUsersFilter() {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}users/allReportFilter`)
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function getRepositoriesFilter() {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}folders/repositories`)
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function getUsers() {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}users`)
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function getDocumentTypes() {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}documenttype`)
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function getDocumentsD4signs(reportFilter) {
        var deferred = $q.defer();

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}revisions/d4Signs/${reportFilter}`
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function getSignD4signs() {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}revisions/SignatorD4`)
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => {
            deferred.reject(err);
          });

        return deferred.promise;
      }

      function docD4sCancel(idRevision) {
        var deferred = $q.defer();
        var url = 'd4sign/document/' + idRevision + '/cancel';
        $http
          .post(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function countCertifiedDocuments() {
        var deferred = $q.defer();

        var url =
          webApiSettings.apiServiceBaseUri + 'dashboard/countCertifiedDocuments/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            deferred.resolve(response.data);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function getOcrProcessingStats() {
        var deferred = $q.defer();
        var url = webApiSettings.apiServiceBaseUri + 'dashboard/ocrProcessingStats/';

        $http.get(url, { ignoreLoadingBar: true }).then(
          function (response) {
            deferred.resolve(response.data);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          var dashboardServiceFactory = {};

          dashboardServiceFactory.getSentDocumentsMonth = logWrapper(
            getSentDocumentsMonth,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getRepositoryGbs = logWrapper(
            getRepositoryGbs,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getUsedGbs = logWrapper(
            getUsedGbs,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.countDocuments = logWrapper(
            countDocuments,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.countFolders = logWrapper(
            countFolders,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.countRegistredUsers = logWrapper(
            countRegistredUsers,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.countIndexedPages = logWrapper(
            countIndexedPages,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.indexedPagesByUser = logWrapper(
            indexedPagesByUser,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.mostActiveUsers = logWrapper(
            mostActiveUsers,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.additionalFieldsReport = logWrapper(
            additionalFieldsReport,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.additionalFieldListItems = logWrapper(
            additionalFieldListItems,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.generateAdditionalFieldReport = logWrapper(
            generateAdditionalFieldReport,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.generateExpiredRevisionsReport = logWrapper(
            generateExpiredRevisionsReport,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.generateIndexedPagesReport = logWrapper(
            generateIndexedPagesReport,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.generateauditUserReport = logWrapper(
            generateauditUserReport,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.generateauditDocumentReport = logWrapper(
            generateauditDocumentReport,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.generatePublicLinkReport = logWrapper(
            generatePublicLinkReport,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.generateDocD4SignReport = logWrapper(
            generateDocD4SignReport,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getUsersFilter = logWrapper(
            getUsersFilter,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getRepositoriesFilter = logWrapper(
            getRepositoriesFilter,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getUsers = logWrapper(
            getUsers,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getDocumentTypes = logWrapper(
            getDocumentTypes,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getDocumentsD4signs = logWrapper(
            getDocumentsD4signs,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getSignD4signs = logWrapper(
            getSignD4signs,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.docD4sCancel = logWrapper(
            docD4sCancel,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.countCertifiedDocuments = logWrapper(
            countCertifiedDocuments,
            runtimeConstant.isDebugServicesInternals
          );
          dashboardServiceFactory.getOcrProcessingStats = logWrapper(
            getOcrProcessingStats,
            runtimeConstant.isDebugServicesInternals
          );

          return dashboardServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
